/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_DeletingInputs */

const en_settings_apikeys_deleting = /** @type {(inputs: Settings_Apikeys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const zh_settings_apikeys_deleting = /** @type {(inputs: Settings_Apikeys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除中...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Settings_Apikeys_DeletingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_deleting = /** @type {((inputs?: Settings_Apikeys_DeletingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_DeletingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_deleting(inputs)
	return zh_settings_apikeys_deleting(inputs)
});
export { settings_apikeys_deleting as "settings.apikeys.deleting" }